import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { SelectionMode } from '../../interfaces';


@Component({
  selector: 'dgx-dfb-address-tabs-wrapper',
  templateUrl: './address-tabs-wrapper.component.html',
  styleUrls: ['./address-tabs-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressTabsWrapperComponent {
  @Input() selectionMode = SelectionMode.Lookup;
  @Output() selectedMode = new EventEmitter<SelectionMode>();

  setSelectionMode(selectionMode: SelectionMode, clickEvent: Event) {
    this.selectedMode.emit(selectionMode);
    clickEvent.preventDefault();
  }
}
